<template>
  <div
    v-if="row"
    class="hierarchy-item"
    @click="selectTopic()"
  >
    <div
      class="hierarchy-title"
      :title="topic.title"
      v-html="'Topic: ' + truncatedTitle()"
    />
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'

export default {
  props: [
    'row',
    'columnIndex'
  ],
  data () {
    return {
      showMenu: {}
    }
  },
  computed: {
    topic () {
      return this.row.rowObject
    }
  },
  methods: {
    truncatedTitle () {
      if (this.topic.title && (this.topic.title.length > 55)) {
        return this.topic.title.substring(0, 55) + '...'
      } else {
        return this.topic.title
      }
    },
    selectTopic () {
      this.$store.commit('appHierarchy/selectRow', {
        columnIndex: this.columnIndex,
        row: this.row
      })

      // EDIT ASSET
      this.edit(this.topic)

      // SET ASSET TYPE
      this.setAssetType({ assetType: 'topic' })
    },
    ...mapMutations([
      'setAssetType'
    ]),
    ...mapActions([
      'edit'
    ])
  }
}
</script>
